<section *ngIf="data"
         class="board-hero-demo-form-panel"
         [class.form-hidden]="data.formHidden.value"
         [class.custom-overlay]="data.overlayColor.value"
         [class.no-space-after]="data.removeSpaceAfterPanel.value"
         [class.no-panel-overlay]="data.removeBackgroundOverlay.value"
         style="position: relative;"
         [ngStyle]="data.backgroundMedia?.value?.image?.src ? {
           'background-image': 'url(' + data.backgroundMedia.value.image.src + ')',
           'background-repeat': 'no-repeat',
           'background-size': 'cover'
         } : null"
         #panelEl>
  <a class="board-hero-demo-form-panel__image-item-holder"
     [href]="data.imageItemLink?.value?.url"
     rel="noopener noreferrer"
     *ngIf="data.imageItem?.value">
    <img [src]="data.imageItem.value.src"
     [alt]="data.imageItem.value.alt"
     [ngStyle]="{aspectRatio: data.imageItem?.value?.width / data.imageItem?.value?.height}" />
  </a>
  <div class="board-hero-demo-form-panel__content" #contentEl>
    <div class="board-hero-demo-form-panel__row">
      <div class="board-hero-demo-form-panel__col"
           [class.full-width]="data.formHidden.value">
        <div [class.no-bottom-gap]="data.items?.value?.length === 0" class="board-hero-demo-form-panel__text-holder">
          <h1 *ngIf="data.title"
              [class.title--capitalize]="data.capitalizeTitle.value"
              class="board-hero-demo-form-panel__text-holder-title"
              [innerHTML]="processedTitle | safe"
              #titleEl></h1>
          <div *ngIf="data.description"
               class="board-hero-demo-form-panel__text-holder--description"
               [innerHTML]="processedDescription | safe"
               #descriptionEl></div>
        </div>
        <div *ngIf="data.items?.value?.length > 0" class="board-hero-demo-form-panel__items-wrapper">
          <div [class.hidden]="data.curve.value === 'None'"
               class="board-hero-demo-form-panel__items-wave board-hero-demo-form-panel__items-wave--top">
            <svg data-name="Layer 1"
                 id="Layer_1"
                 viewBox="0 0 1440 80"
                 xmlns="http://www.w3.org/2000/svg">
              <path class="st0"
                    fill="#272b3e"
                    d="M685.6,56.38C418.7,6.48,170.2,27.48,0,47.58v137l1440-.07V47.58C1252.7,69.78,1010,117,685.6,56.38Z"
                    transform="translate(0 -25.54)"></path>
            </svg>
          </div>
          <h3 *ngIf="data.itemsTitle"
              class="board-hero-demo-form-panel__items-title">
            {{ data.itemsTitle.value }}
          </h3>
          <ul class="board-hero-demo-form-panel__items">
            <li *ngFor="let item of data.items.value" class="board-hero-demo-form-panel__item">
              <a *ngIf="item.link?.value?.url"
                 [href]="item.link.value.url"
                 [attr.target]="item.link.value.target"
                 rel="noopener noreferrer">
                <img [src]="item.image.value.src"
                     [alt]="item.image.value.alt"
                     [ngStyle]="{aspectRatio: item.image?.value?.width / item.image?.value?.height}"
                     fetchpriority="high"
                    />
              </a>

              <img *ngIf="!item.link?.value?.url"
                   [src]="item.image.value.src"
                   [ngStyle]="{aspectRatio: item.image?.value?.width / item.image?.value?.height}"
                   [alt]="item.image.value.alt"
                   fetchpriority="high"
                  />
            </li>
          </ul>
          <div [class.hidden]="data.curve.value === 'None'" class="board-hero-demo-form-panel__items-wave">
            <svg data-name="Layer 1"
                 id="Layer_1"
                 viewBox="0 0 1440 80"
                 xmlns="http://www.w3.org/2000/svg">
              <path class="st0 index-last-wave"
                    d="M685.6,56.38C418.7,6.48,170.2,27.48,0,47.58v137l1440-.07V47.58C1252.7,69.78,1010,117,685.6,56.38Z"
                    transform="translate(0 -25.54)"></path>
            </svg>
          </div>
        </div>

        <div *ngIf="buttons && buttons.length > 0 || buttonsAsLink.length > 0"
             [class.bottom-gap]="data.items?.value?.length === 0"
             class="board-hero-demo-form-panel__items board-hero-demo-form-panel__buttons-wrapper">
          <ng-container *ngFor="let item of buttons; let i = index">
            <ng-container *ngIf="item.button.value && (item.button.value.type !== buttonType.external && !isButtonMediaInternalVideo(item.button.value))">
              <a href="{{ item.button.value.url }}"
                 target="{{ item.button.value.target || '_self' }}"
                 class="board-hero-demo-form-panel__button bg-green-button">
                {{ item.button.value.name }}
              </a>
            </ng-container>

            <ng-container *ngIf="item.button.value && (item.button.value.type === buttonType.external || isButtonMediaInternalVideo(item.button.value))">
              <button (click)="openModalVideo(i)"
                      type="button"
                      class="board-hero-demo-form-panel__button bg-green-button">
                {{ item.button.value.name }}
              </button>

              <app-modal-video *ngIf="item.isModalShow"
                               [isShow]="item.isModalShow"
                               (close)="closeModalVideo(i)"
                               [data]="prepareVideoData(item.button.value)"></app-modal-video>
            </ng-container>
          </ng-container>

          <ng-container *ngFor="let item of buttonsAsLink">
            <ng-container *ngIf="item.button.value">
              <a href="{{ item.button.value.url }}"
                 target="{{ item.button.value.target || '_self' }}"
                 class="board-hero-demo-form-panel__button board-hero-demo-form-panel__button--as-link">
                {{ item.button.value.name }}
              </a>
            </ng-container>
          </ng-container>
        </div>
      </div>

      <div *ngIf="!data.formHidden.value"
           class="board-hero-demo-form-panel__col">
        <div class="board-hero-demo-form-panel__form-holder">
          <h2 class="board-hero-demo-form-panel__form-holder--title"
              *ngIf="data.formTitle">
            {{ data.formTitle.value }}
          </h2>

          <form [formGroup]="demoGroup" (ngSubmit)="sendRequest($event)">
            <div class="board-hero-demo-form-panel__form-holder-field"
                 [ngClass]="validateFormField('name')">
              <input formControlName="name"
                     type="text"
                     id="form-name"
                     placeholder="{{ formText.name }}"
                     class="board-hero-demo-form-panel__form-holder-text" />
            </div>
            <div class="board-hero-demo-form-panel__form-holder-field"
                 [ngClass]="validateFormField('email')">
              <input formControlName="email"
                     type="text"
                     id="form-email"
                     placeholder="{{ formText.email }}"
                     class="board-hero-demo-form-panel__form-holder-text" />
            </div>
            <div class="board-hero-demo-form-panel__form-holder-field"
                 [ngClass]="validateFormField('phone')">
              <input formControlName="phone"
                     type="tel"
                     id="form-phone"
                     placeholder="{{ formText.phone }}"
                     class="board-hero-demo-form-panel__form-holder-text" />
            </div>
            <div class="board-hero-demo-form-panel__form-holder-field"
                 [ngClass]="validateFormField('company')">
              <input formControlName="company"
                     type="text"
                     id="form-company"
                     placeholder="{{ formText.company }}"
                     class="board-hero-demo-form-panel__form-holder-text" />
            </div>
            <div class="board-hero-demo-form-panel__form-holder--privacy-policy">
              <input type="checkbox"
                     formControlName="privacyPolicy" />
              <p>
                {{ "boardHeroDemoFormPanel.PrivacyPolicy.Label" | translate }} <a *ngIf="data.cookiePolicyPageUrl"
                                                                                  [routerLink]="data.cookiePolicyPageUrl" target="_blank">
                  {{"boardHeroDemoFormPanel.PrivacyPolicy.Link" | translate }}
                </a>
              </p>
            </div>
            <br />
            <re-captcha (resolved)="reCaptchaValidated($event)"
                        #captcha="reCaptcha"
                        siteKey="{{ data.reCaptchaSecret }}"
                        class="board-hero-demo-form-panel__re-captcha">
            </re-captcha>
            <div class="board-hero-demo-form-panel__form-holder--submit">
              <div *ngIf="errMsg"
                   class="board-hero-demo-form-panel__form-holder--error">
                {{ errMsg }}
              </div>
              <button type="button"
                      (click)="sendRequest($event)"
                      class="board-hero-demo-form-panel__form-holder--link bg-green-button">
                {{ data.formButtonText.value }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="data.backgroundMedia?.value?.video; then videoBlock"></div>

  <div *ngIf="data.curve.value === 'Wave'" class="wave">
    <svg data-name="Layer 1"
         id="Layer_1"
         viewBox="0 0 1440 80"
         xmlns="http://www.w3.org/2000/svg">
      <path class="st0 index-last-wave"
            d="M685.6,56.38C418.7,6.48,170.2,27.48,0,47.58v137l1440-.07V47.58C1252.7,69.78,1010,117,685.6,56.38Z"
            transform="translate(0 -25.54)"></path>
    </svg>
  </div>

  <div *ngIf="requestSuccess === true"
       class="board-hero-demo-form-panel__modal">
    <div class="board-hero-demo-form-panel__modal--content">
      <p>{{ succMsg }}</p>
    </div>
  </div>

  <bottom-curve *ngIf="data.curve.value === 'Curve'"></bottom-curve>
</section>

<ng-template #videoBlock>
	<div 
		#mediaHolder 
		*ngIf="media" 
		class="board-hero-video-panel__media-holder board-hero-video-panel__media-holder--with-video"
		[ngClass]="{'board-hero-video-panel__media-holder--no-overlay': data?.removeBackgroundOverlay?.value}"
	>
		<ng-container *ngIf="!isMobile">
			<div *ngIf="media.desktop.type === 2; then videoDeskLocalBlock; else videoDeskNoLocalBlock"></div>
		</ng-container>
		<ng-container *ngIf="isMobile">
			<div *ngIf="media.mobile.type === 2; then videoMobLocalBlock; else videoMobNoLocalBlock"></div>
		</ng-container>
	</div>
</ng-template>

<ng-template #videoDeskNoLocalBlock>
	<app-iframe 
		class="board-hero-video-panel__video board-hero-video-panel__video--desktop" 
		[src]="media.desktop.url"
		[videoCode]="media.desktop.videoCode"
		[params]="''"
	></app-iframe>
</ng-template>

<ng-template #videoMobNoLocalBlock>
	<app-iframe 
		class="board-hero-video-panel__video board-hero-video-panel__video--mobile" 
		[src]="media.mobile.url"
		[videoCode]="media.mobile.videoCode"
		[params]="''"
	></app-iframe>
</ng-template>

<ng-template #videoDeskLocalBlock>
	<video 
		preload="true" 
		autoplay="autoplay" 
		loop="loop" 
		[muted]="'muted'" 
		name="media"
		class="board-hero-video-panel__video board-hero-video-panel__video--desktop"
    fetchpriority="high"
	>
    <source [src]="media.desktop.url" type="video/mp4">
  </video>
</ng-template>

<ng-template #videoMobLocalBlock>
	<video 
		preload="true" 
		autoplay="autoplay" 
		loop="loop" 
		[muted]="'muted'" 
		name="media"
		class="board-hero-video-panel__video board-hero-video-panel__video--mobile"
    fetchpriority="high"
	>
    <source [src]="media.mobile.url" type="video/mp4">
  </video>
</ng-template>

